@let analysis = view();
<div data-testid="analysis-calculation">
  <div class="my-3">
    <app-coverage-section titleKey="project.steps.rfi.invitationList.analysis.calcHowTitle">
      <p>{{ 'project.steps.rfi.invitationList.analysis.calculationIntro' | transloco }}</p>
      @if (analysis.example; as example) {
        <app-coverage-note class="mt-3 block">
          {{
            'project.steps.rfi.invitationList.analysis.calcExample'
              | transloco
                : {
                    function: example.functionName,
                    weight: (example.weightShare | appNumber: '1.2-2') + ' %',
                    country: example.countryName,
                    employees: (example.employees | appNumber: '1.0-0'),
                    points: (example.points | appNumber: '1.0-0'),
                  }
          }}
        </app-coverage-note>
      }
    </app-coverage-section>
  </div>

  <div class="my-3">
    <app-coverage-section titleKey="project.steps.rfi.invitationList.analysis.subtotalsTitle">
      <table class="ca-table">
        <app-coverage-table-head [columns]="subtotalColumns" />
        <tbody>
          @for (subtotal of analysis.subtotals; track subtotal.functionName) {
            <tr>
              <td>{{ subtotal.functionName }}</td>
              <td>{{ subtotal.weightShare | appNumber: '1.2-2' }} %</td>
              <td class="text-right tabular-nums">{{ subtotal.employees | appNumber: '1.0-0' }}</td>
              <td class="text-right tabular-nums">
                {{ subtotal.possiblePoints | appNumber: '1.0-0' }}
              </td>
              <td class="text-right tabular-nums text-green">
                {{ subtotal.achievedPoints | appNumber: '1.0-0' }}
              </td>
              <td
                class="text-right tabular-nums"
                [ngClass]="{'text-red': subtotal.missingPoints > 0}"
              >
                {{ subtotal.missingPoints | appNumber: '1.0-0' }}
              </td>
            </tr>
          }
        </tbody>
      </table>
    </app-coverage-section>
  </div>

  <div class="my-3">
    <app-coverage-section
      titleKey="project.steps.rfi.invitationList.analysis.cellsTitle"
      subtitleKey="project.steps.rfi.invitationList.analysis.cellsHint"
    >
      <app-coverage-option-toggle
        sectionAction
        inputId="only-missing-points"
        labelKey="project.steps.rfi.invitationList.analysis.onlyMissingPoints"
        [(checked)]="onlyMissingPoints"
      />
      <div class="max-h-[290px] overflow-auto">
        <table class="ca-table">
          <app-coverage-table-head [columns]="calculationColumns" />
          <tbody>
            @for (row of visibleCalculationRows(); track $index) {
              <tr [ngClass]="{'bg-red-950': !row.covered}" data-testid="analysis-cell-row">
                <td>{{ row.functionName }}</td>
                <td>{{ row.isoCode }}</td>
                <td>{{ row.weightShare | appNumber: '1.2-2' }} %</td>
                <td>{{ row.employees | appNumber: '1.0-0' }}</td>
                <td class="text-right tabular-nums">
                  {{ row.possiblePoints | appNumber: '1.0-0' }}
                </td>
                <td class="text-right tabular-nums" [ngClass]="{'text-green': row.covered}">
                  {{ row.achievedPoints | appNumber: '1.0-0' }}
                </td>
                <td class="text-right tabular-nums" [ngClass]="{'text-red': !row.covered}">
                  @if (row.covered) {
                    —
                  } @else {
                    −{{ row.possiblePoints | appNumber: '1.0-0' }}
                  }
                </td>
              </tr>
            } @empty {
              <tr>
                <td colspan="7" class="text-muted-color text-sm text-center">
                  {{ 'project.steps.rfi.invitationList.analysis.noMissingPoints' | transloco }}
                </td>
              </tr>
            }
          </tbody>
        </table>
      </div>
    </app-coverage-section>
  </div>

  <div
    class="rounded-md border border-emerald-700 bg-emerald-950 p-3.5 mt-3.5"
    data-testid="analysis-calculation-result"
  >
    <h4 class="text-base font-semibold mb-2.5">
      {{ 'project.steps.rfi.invitationList.analysis.resultTitle' | transloco }}
    </h4>
    <div>
      {{ 'project.steps.rfi.invitationList.analysis.possiblePointsLabel' | transloco }}
      <b>{{ analysis.possiblePoints | appNumber: '1.0-0' }}</b>
    </div>
    <div>
      {{ 'project.steps.rfi.invitationList.analysis.achievedPointsLabel' | transloco }}
      <b class="text-green">{{ analysis.achievedPoints | appNumber: '1.0-0' }}</b>
    </div>
    <div>
      {{ 'project.steps.rfi.invitationList.analysis.missingPointsLabel' | transloco }}
      <b class="text-red">{{ analysis.missingPoints | appNumber: '1.0-0' }}</b>
    </div>
    <hr class="border-themed my-3 border-0 border-t" />
    <b>
      {{
        'project.steps.rfi.invitationList.analysis.resultFormula'
          | transloco
            : {
                achieved: (analysis.achievedPoints | appNumber: '1.0-0'),
                possible: (analysis.possiblePoints | appNumber: '1.0-0'),
                score: (analysis.score | appNumber: '1.2-2'),
              }
      }}
    </b>
  </div>
  <p class="text-muted-color text-sm mt-3">
    {{ 'project.steps.rfi.invitationList.analysis.calcFootnote' | transloco }}
  </p>
</div>
